// 阿拉伯
export default {
    dialog: {
        msgShow: "الاشعارات / الاشعار",
        buttonOk: 'موافق /',
        buttonCancel: 'الغاء',
    },
    photoBrowser: {
        bannerPhotoBrowser: 'اغلاق / مغلق'
    },
    employeeNumber: 'بطاقة الفني',
    pleaseEnterEmployeeNumber: 'برجاء ادخال بطاقة الفني',
    password: 'رمز الدخول',
    pleaseEnterPassword: 'برجاء ادخال رمز الدخول',
    login: 'تسجيل الدخول',
    required: 'سجل ضروري / مطلوب',
    synchronize: 'تزامن',
    salesOrder: 'تقرير صيانه',
    pleaseEnterHome: 'ادخل اسم العميل / تقرير الخدمة',
    searchFilter: 'البحث و التصفيه',
    machineSpecifications: 'النموذج والمواصفات',
    processingStatus: 'الحاله الراهنه',
    processing: 'قيد التنفيذ',
    finish: 'اكتمال',
    waitCountermeasures: null,
    reset: 'الرجوع',
    submit: 'ارسال',
    muMachineInvestigation: 'استخدام الماكينه',
    logout: 'تسجيل الخروج',
    searchDate: 'البحث عن التاريخ',
    time: 'البحت عن الوقت',
    basicInformation: 'بيانات العميل',
    addSalesOrder: 'اضافة تقرير خدمة',
    save: 'حفظ',
    date: 'التارخ',
    pleaseSelectDate: 'برجاء اختيار التاريخ / اختيار التاريخ',
    travelNumber: 'ملف تقرير صيانة',
    pleaseEnterTravelNumber: 'برجاء ادخال رقم ملف الصيانه / ادخال ملف الصيانه',
    customerCode: 'كود العميل',
    pleaseEnterCustomerCode: 'برجاء ادخال كود العميل / ادخال كود العميل',
    customerName: 'اسم العميل',
    pleaseEnterCustomerName: 'برجاء ادخال اسم العميل / ادخال اسم العميل',
    country: 'منطقة الدولة',
    pleaseEnterCountry: 'ادخل منطقة الدولة',
    customerAddress: 'عنوان العميل',
    pleaseEnterAddress: 'ادخل عنوان العميل',
    customerContact: 'رقم هاتف العميل',
    pleaseEnterContact: 'ادخل رقم هاتف العميل',
    salesRepresentative: 'ممثل المبيعات',
    pleaseEnterSalesRepresentative: 'ادخل اسم ممثل المبيعات',
    hint: 'اشعار / اشعارات',
    createDate: 'تاريخ البدء',
    salesOrderNumber: 'رقم ملف التقرير',
    customerSatisfaction: 'رضي العميل',
    maintenancePersonnel: 'فني',
    maintenanceTime: 'وقت الصيانه',
    customerConfirmation: 'تأكيد العميل',
    copy: 'نسخ',
    delete: 'مسح',
    recordTime: 'مده التسجيل / مده السجل',
    machineNumber: 'رقم الماكينه / رقم صيانه الماكينه',
    copyToSalesOrder: 'نسخ في ملف الصيانه / نسخ في',
    copyTo: 'نسخ الي',
    selectSalesOrderNumber: 'اختيار ملف الصيانه',
    pleaseEnterSalesOrderNumber: 'اختار رقم ملف تقرير الصيانة',
    latitudeAndLongitude: 'خطوط العرض و خطوط الطول',
    startMaintenance: 'بدء الصيانه',
    endMaintenance: 'انتهاء الصيانه',
    newMachine: 'تقرير التركيب',
    maintenance: 'صيانة الماكينة',
    addMachineServiceOrder: 'اضافه ملف صيانه للماكينه',
    selectType: 'اختيار النوع',
    generalMaintenance: 'صيانة الماكينة',
    oilEducationTraining: 'التدريب بمختبر التدريب المفتوح',
    pleaseEnterMachineNumber: 'ادخل رقم الماكينه',
    manufacturingDate: 'تاريخ التصنيع (اكتب تاريخ الضمان , لا داعي له بعد انتهاء فتره الضمان )',
    pleaseSelectManufacturingDate: 'اختيار تاريخ التصنيع',
    maintenanceWarranty: 'الصيانه في مده الضمان ( سنه واحده )',
    underWarranty: 'الصيانه في مده الضمان',
    warrantyExpired: 'انتهاء مدة الضمان',
    confirm: 'تم',
    cancel: 'الغاء',
    addMaintenancePersonnel: 'ادخال / اضافة اسم الفني',
    maintenanceTimeTotal: 'مجموع وقت الصيانه',
    day: 'الايام',
    hour: 'الساعات',
    enterFactory: 'بدء الصيانه',
    pleaseSelectEnterFactory: 'اختار بدء الصيانه',
    longitude: 'خطوط طول',
    // pleaseEnterLongitude: 'برجاء ادخال خطوط العرض',
    latitude: 'خطوط العرض',
    // pleaseEnterLatitude: 'برجاء ادخال خطوط الطول',
    leaveFactory: 'انتهاء الصيانه',
    pleaseSelectLeaveFactory: 'برجاء اختيار انهاء الصيانه',
    duration: 'وقت الصيانه',
    pleaseEnter: 'برجاء الادخال',
    selectTime: 'اختار التاريخ و اختيار الوقت',
    selectSatisfaction: 'رضي العميل',
    verySatisfied: 'راضي جدا',
    satisfied: 'مرضي',
    ordinary: 'عادي / طبيعي',
    dissatisfied: 'استياء',
    veryDissatisfied: 'استياء شديد',
    opinionReply: 'تعليقات العميل',
    takePhoto: 'اخذ صوره',
    uploadFile: 'رفع ملف',
    audio: 'ملف صوتي',
    video: 'ملف مصور / ملف فيديو',
    electronicSignature: 'توقيع العميل',
    signatureDate: 'تاريخ التوقيع',
    clear: 'حذف',
    machineInformation: 'بيانات الماكينه',
    machineFunction: 'فحص الماكينة',
    organizationArrangement: 'هيكل البناء و النمط',
    spareParts: 'قطع',
    operationProcedure: 'سجل الاختبار',
    problemHandling: 'العمليه',
    trainee: 'المتدرب',
    coursePlan: 'خطة الكورس',
    courseSchedule: 'جدول الكورس',
    inputVoltageAndCurrent: 'ادخل الفولت و الامبير',
    lowSpeed: 'اقل سرعه',
    highSpeed: 'اعلي سرعه',
    accelerationDecelerationSlope: 'تسارع و تباطئ منحدر',
    acceleration: 'تسارع المنحدر',
    deceleration: 'تباطئ المنحدر',
    clothRoller: 'شداد',
    left: 'يسار',
    center: 'وسط',
    right: 'صحيح / يمين',
    yarnFeedingTeeth: 'بكرة الجوده / الترس',
    saddleRingDistance: 'المسافه بين رنج حامل الكامات و الاطار',
    yarnNozzleNumber: 'مكوك',
    height: 'طول',
    spacing: 'فرق / فجوه',
    warpYarnInfo: 'قماش رمادي',
    inch: 'بوصات',
    cm: 'سم',
    timeSequence: 'التوقيتات',
    needle: 'الابر',
    yarnSpecification: 'مواصفات الغزول',
    yarn: 'الغزول',
    serialNumber: 'ارقام ماكينات اخري',
    technician: 'فني',
    series: 'مسلسل الاقمشه',
    fabricType: 'انواع الاقمشه',
    productFeatures: 'مواصفات المنتج',
    inputVoltage: 'ادخل الفولت',
    inputCurrent: 'ادخا الامبير',
    electronicWindingTensionUpper: 'امبير الرولر الالكتيروني (العلوي)',
    electronicWindingTensionLower: 'امبير الرولر الالكتيروني (السفلي)',
    mechanicalType: 'ترس الرولر الميكانيكي',
    lowerNeedleDistanceToSeatRing: 'المسافه بين السلندر و رنج حامل الكامات',
    upperNeedleDistanceToSeatRing: 'المسافه بين الدايل ورنج حامل الكامات',
    upperNeedleDistanceToLowerNeedleNozzle: 'المسافه بين الدايل وحافه السلندر',
    selectorNeedleRingDistanceToTakeUpPlate: 'المسافه بين رنج المحرك والإطار',
    seatRingDistanceToTakeUpPlate: 'المسافه بين رنج حامل الكامات و الاطار',
    machineSpeed: 'عدد لفات دوران الماكينه',
    inverterFrequency: 'المحول بالهرتز',
    yarnCount: '目數',
    gramsPerSquareMeter: 'وزن القطعة بالجرام للسم',
    yardsPerPound: 'وزن القطعة بالجرام لليارده',
    customerYarnWidth: 'العرض',
    customerSpecifiedYarnLength: 'تعيين طول الغرزه',
    newCustomerPackageTiming: 'اوقيت السنكر',
    doubleSidedCuttingTiming: 'توقيت كامات الديل',
    nozzleTiming: 'توقيت حامل الغزل',
    yarnCode: 'كود الغزل',
    yarnType: 'مواصفات الغزول',
    color: 'اللون',
    yarnSize: 'رقم الغزل',
    fiberCount: '纖維數',
    innerFiber: 'فرو داخل',
    outerFiber: 'فرو خارج',
    flatness: 'مغدل الاستواء',
    roundness: 'معدل الدوران',
    windPressure: 'ضغط الهواء',
    appearance: 'الظهور',
    machineLevel: 'معدل استواء اطار الماكينة 0.01 مم',
    trident: 'معدل استواء الدايل و معدل دوران الديل',
    highLegWinder: 'شداد الارجل المرتفعه',
    fabricSlitting: 'شداد الماكينات الاوبن ويدز',
    inverterCurrent: 'امبير المحول',
    machineFunctionFrame: 'بطاريات التغذيه بالخيوط و الرنج و الدواليب',
    inchStart: 'وظيفة زر الهروله و البدء و الايقاف',
    firstSecondSpeed: 'وظيفة زر السرعه و المصباح و المروحه',
    firstSecondSpeed2: 'وظيفه اعدادات السرعه',
    controllerOtherFunctions: 'وظيفائف التحكم الاخري',
    electricalBoxSignals: 'الاشارات و الحساسات',
    fanDustRemovalAction: 'تشغيل المروحه',
    oilSprayerAction: 'تشغيل المزيته',
    airBlowerSystemAction: 'ضغط الهواء و تشغيله',
    windingAction: 'طريقه تشغيل الشداد',
    machineControllerOperationTutorial: 'التدريب علي تشغيل لوحة التحكم',
    machineOperationTutorial: 'التدريب علي تشغيل الماكينه',
    other: 'اخري',
    descriptionAndAttachment: 'مرجع',
    upperNeedleArrangement: 'ترتيب ابر الدايل',
    upperKnifeArrangement: 'ترتيب سكاكين الدايل',
    lowerNeedleArrangement: 'ترتيب ابر السلندر',
    lowerNeedleArrangementShort: 'ترتيب ابر السلندر',
    lowerKnifeArrangement: 'ترتيب سكاكين السلندر',
    lowerKnifeArrangementShort: 'ترتيب سكاكين السلندر',
    upperNeedlePlate: 'الدايل',
    lowerNeedleCylinder: 'السلندر',
    blank: 'المسافه',
    blockRule: 'اداة قياس',
    retractionBaseline: 'المسافه بين ظهر الابلاتين و الابر',
    upperPlateNeedleWithdrawalKnob: 'مقبض عيار الدايل',
    upperPlateNeedleWithdrawalDepth: 'مكان غرزه الدايل',
    upperPlateHalfNeedleHeight: 'مكان كامه الهرمه و النص طلعه بالديل',
    upperPlateFlatNeedleHeight: 'مكان كامه اللغي بالديل',
    lowerCylinderFlatNeedleHeight: 'مكان و كامه اللغي بالسلندر',
    lowerCylinderFlatNeedleDepth: 'مكان غرزه السلندر',
    lowerCylinderNeedleWithdrawalKnob: 'مقبض عيار السلندر',
    yarnTypeCode: 'كود الغزل',
    yarnTypeTensionN: 'شدد الغزل',
    cmPer100Needles: 'طول الغرزه /100N',
    feedYarnLengthPerRevolution: 'طول الغرزه / 1',
    aluminumPlateYarnFeedingDepthCm: 'مقاس بكره الشداد بالسم .',
    yarnFeedingAluminumPlateScale: 'علامه بكره الشداد',
    newCustomerPackage: 'ابلاتين',
    upperPlate: 'دايل',
    lowerCylinder: 'سلندر',
    yarnShort: 'غزول',
    pleaseEnterProductName: 'ادخل وصف القطع',
    pleaseEnterProductNumber: 'ادخل عدد القطع',
    quantity: 'عدد',
    damage: 'مكسور',
    missing: 'ناقص',
    wrong: 'خطأ',
    pleaseEnterTitle: 'اضافة عنوان',
    pleaseEnterContent: 'اضافة موضوع',
    addQuestionItem: 'اضافة سؤال',
    questionProcessingRecord: 'سجل التدابير الاحترازيه',
    pleaseEnterQuestionDescription: 'ادخل وصف المشكله',
    traineeAndClient: 'متدرب / عميل',
    trainer: 'متدرب',
    drawingFunction: 'وظيفه برنامج CAD',
    upperMachineProgram: 'برنامج الماكينه',
    UnravelingFunction: 'تحليل عينه القماش',
    courseName: 'اسم الكورس',
    pleaseEnterCourseName: 'ادخل اسم الكورس',
    imageName: 'اسم ملف النمط',
    pleaseEnterImageName: 'ادخل رقم رقم لوحه باسم الملف',
    confirmItem: 'تاكيد',
    undone: 'غير مكتمل',
    pleaseEnterInquire: 'ادخل اسم العميل , MU وثيقه',
    machineUtilizationSurvey: 'استخدام الماكينه',
    customerID: 'كود العميل',
    pleaseEnterCustomerID: 'ادخل كود العميل',
    pleaseSelect: 'اختيار',
    pleaseEnterSkill: 'ادخال المهاره',
    pleaseEnterBuyer: 'ادخال المشتري',
    pleaseEnterRemark: 'ادخل علامه',
    source: 'مصدر',
    selfInput: '自行輸入',
    textileEquipment: 'ماكينه نسيج',
    textileMachineBrand: 'براند ماكينه النسيج',
    textileMachineType: 'موديل ماكينه النسيج',
    notSelected: 'ليس بعد',
    select: 'اختيار',
    brand: 'الماركة',
    totalMachine: 'عدد الماكينات',
    openRate: '% من استخدام الماكينه',
    dailyOutput: 'الانتاجيه (الطن / اليوم)',
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: 'برجاء ادخال محتوي التغيير',
    // alert
    editNotSave: 'لم يتم حفظ التغييرات , هل انت واثق من اغلاق البرنامج',
    deleteConfirm: 'هل انت واثق من اجراء المسح',
    confirmClearSignature: 'هل انت واثق من ازاله التوقيع',
    confirmWriteData: 'هل انت واثق من ادخالك للتاريخ الصحيح ؟',
    confirmCopyToSalesOrder: 'هل انت واثق من انك تريد نسخ البيانات الي تقرير الخدمه هذا ؟',
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: 'تم المسح بنجاح',
    clearSuccess: 'تم النقل بنجاح',
    copySuccess: 'تم النسخ بنجاح',
    selectWorker: 'برجاء اختيار اسم الميكانيكي',
    selectProblem: 'برجاء اختيار بند السؤال',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',
    //new
    selectDate: 'اختيار التاريخ',
    yarnTensionN: 'شدد الغزل',
    category: 'نوع',
    kind: 'موديل',
    // pleaseSelectType: 'اختيار النوع',
    dateInOutError: 'تاريخ انهاء خدمه الصيانه يجب ان يكون دائما مساويا او بعد تاريخ بدء الخدمة',
    yarnFeedingTeethOrDisc: 'بكرة الجوده / الترس',
    changed: 'تم التغيير',
    pleaseSelectSparePartsStatus: 'برجاء اختيار حاله الاكسسوارات',
    pleaseEnterDuration: 'برجاء ادخال وقت الصيانه',

    // API語系
    saveComplete: 'تم الحفظ بنجاح',
    needOnline: 'Need Online.',
    addComplete: 'تمت الاضافة بنجاح',
    reportCreator: 'انشاء تقرير',
    onlineGenerate: 'Generate after uploading',
    synchronizeFail: '同步異常',
    synchronizeSuccess: 'تمت المزامنة بنجاح',
    downloadFail: '下載異常',
    downloadSuccess: 'تم التحميل بنجاح',
    synchronizeSelect: 'اختيار التزامن',
    onlySynchronizeOffData: 'تحميل البيانات الالكترونية',
    synchronizeData: null,
    synchronizeImage: 'مزامنة الصور',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: 'تحميل البيانات في حالة عدم الاتصال بالشبكة',
    downloadOfflineImage: 'تحميل الصور في حالة عدم الاتصال بالشبكة',
    synchronizing: 'جاري التزامن , برجاء الانتظار . لا تغلق شاشة التطبيق',
    downloading: 'تحميل, برجاء الانتظار لا تغلق شاشة البرنامج',
    confirmDownload: '؟ التحميل سوف يعدل علي البيانات الموجوده في حالة عدم الاتصال بالشبكه',
    confirmSynchronization: '؟ المزامنة سوف تزامن البيانات المشابهه في حاله اتصال الشبكة',
    overwriteOffline : 'هل تاكد علي التحميل',
    synchronizationOnline: 'هل تؤكد علي المزامنة ',
    uploadFail: '上傳異常',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: 'رتب علي حسب انشاء الطلب',
    sortByType: 'رتب علي حسب النوع',
    reportDownload: 'تقرير',
    selectServiceReport: 'اختر تقرير الخدمة',
    enterServiceReportOrMachine: 'أدخل رقم تقرير الخدمة أو رقم الجهاز”.',
    selectAll: 'اختر الكل',

    downloadHint:null
}
